'use strict';

var React = require('react');

var SvgCustomerMinusMajor = function SvgCustomerMinusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 11h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2zm-1.637-5.78a4.22 4.22 0 1 1-8.439-.001 4.22 4.22 0 0 1 8.439 0zm-11.693 9.249c1.384-1.09 4.141-2.853 7.474-2.853 3.332 0 6.089 1.764 7.474 2.853.618.486.81 1.308.567 2.056l-.333 1.02a2.11 2.11 0 0 1-2.006 1.455h-11.405a2.11 2.11 0 0 1-2.005-1.455l-.333-1.02c-.245-.748-.052-1.57.566-2.056zm-2651.67 430.531h100v100h-100v-100z"
  }));
};

exports.SvgCustomerMinusMajor = SvgCustomerMinusMajor;
